import CTL_Footer from "@/compo/CTL_Footer";
import CTL_TopMenubar from "@/compo/CTL_TopMenubar";
import { useEffect, useRef } from "react";
import { Outlet, useLocation, } from "react-router";

const subMenuList =[
  {label:'홈', to:'/'},
  {label:'공지사항', to:'/notice'},
  {label:'대회 정보', to:'/game'},
]

export default function DefaultLayout(){
  //console.log('>render layout')
  const scrPanel = useRef<HTMLDivElement>(null);
  const location = useLocation();
  useEffect(()=>{
    //console.log('scrPanel',scrPanel.current!.scrollTop )
    scrPanel.current!.scrollTo({top:0})
  },[location])
  return <>
  <div className="
    overflow-hidden
    w-screen h-screen 
    flex flex-col
    items-center
    bg-zinc-100 
    ">
    
    <div className="
      flex-1 bg-white 
      xs:w-[440px] w-full 
      max-h-full
      flex flex-col
    ">
      <CTL_TopMenubar menuList={subMenuList}/>
      <div ref={scrPanel} className=" 
        flex-1  overflow-y-auto
      ">
          <div className="px-3 pt-3 min-h-[calc(100%-200px)]">
            <Outlet/>
          </div>
          <CTL_Footer />        
  
      </div>
    </div>
  </div>
  </>
}